import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { supabase } from '../../lib/supabaseClient';
import { trackMarketingGoogleSignupClick } from '../../lib/marketingEvents';

export function SocialProviders({ setError, setMessage, setView }) {
  const { t, i18n } = useTranslation();
  const [loading, setLoading] = useState(false);

  const handleGoogle = async () => {
    setError('');
    setMessage('');
    setLoading(true);
    try {
      const siteUrl = process.env.REACT_APP_SITE_URL || window.location.origin;
      const lang = (i18n.language || 'en').split('-')[0];
      trackMarketingGoogleSignupClick({ source: 'auth_modal', language: lang });

      const { error } = await supabase.auth.signInWithOAuth({
        provider: 'google',
        options: {
          redirectTo: `${siteUrl}/?lang=${encodeURIComponent(lang)}`,
        },
      });
      if (error) throw error;
    } catch (err) {
      setError(err.message || t('auth.errors.social', 'No se pudo iniciar sesión con el proveedor seleccionado'));
      setLoading(false);
      setView('register');
    }
  };

  return (
    <div className="mb-4">
      <button
        type="button"
        onClick={handleGoogle}
        disabled={loading}
        className="w-full rounded-lg border border-gray-600 bg-white px-4 py-3 text-sm font-semibold text-gray-950 transition hover:bg-gray-100 disabled:cursor-not-allowed disabled:opacity-70"
      >
        {loading ? t('common.loading', 'Procesando...') : t('auth.with.google', 'Continuar con Google')}
      </button>
      <div className="mt-4 flex items-center gap-3 text-xs text-gray-500">
        <span className="h-px flex-1 bg-gray-700" />
        <span>{t('auth.or', 'o')}</span>
        <span className="h-px flex-1 bg-gray-700" />
      </div>
    </div>
  );
}
